import React, { useEffect, useState } from "react";
import { Tooltip, Form, Button, Badge, message, Popconfirm } from "antd";
import { connect } from "dva";
import { router } from "umi";
import moment from "moment";
import Container from "../../../../components/Container";
import ListPage from "../../../../components/ListPage";
import ListSearch from "../Components/HooksSearch";
import OperateDropdown from "../../../../components/OperateDropdown";
import useRequest from "../hooks/use-table-state";
import {
  getLessonList,
  deleteLesson
} from "../../../../services/doubleTeacherClass/list";
import { getClassRoomList } from "../../../../services/doubleTeacherClass/global";
import { getComposeUrl } from "../../../../utils/common";
import styles from "./index.less";

const { ListTable } = ListPage;
const statusIcon = {
  1: "warning",
  2: "processing",
  3: "default"
};
const statusText = {
  1: "待开课",
  2: "进行中",
  3: "已结束"
};

const Selected = props => {
  const {
    pageInfo,
    list,
    loading,
    handlePaginationChange,
    handleQueryChange
  } = useRequest(getLessonList);

  const [classRoomList, setClassRoomList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    getClassRoomList().then(res => {
      setClassRoomList(res);
    });
  }, []);

  // 跳转观看直播地址
  const handleGoToWatchLesson = record => {
    const { platformUrl } = record;
    if (platformUrl) {
      window.open(platformUrl);
    } else {
      message.error("乐享创建失败");
    }
  };

  // 删除课程
  const handleDeleteLesson = record => {
    setPageLoading(true);
    const { id } = record;
    deleteLesson({ id })
      .then(() => {
        setPageLoading(false);
        message.success("删除成功");
        handleQueryChange({});
      })
      .catch(() => {
        setPageLoading(false);
      });
  };

  // 观看课程
  const renderWatchLesson = record => {
    return <a onClick={() => handleGoToWatchLesson(record)}>观看课程</a>;
  };

  // 删除课程
  const renderDeleteLesson = record => {
    return (
      <Popconfirm
        title="确认删除？"
        okText="确认"
        cancelText="取消"
        className="del"
        onConfirm={() => handleDeleteLesson(record)}
      >
        <a>删除</a>
      </Popconfirm>
    );
  };

  // 进行中 状态下 操作
  const renderOnGoingAction = record => {
    const data = [
      {
        text: renderWatchLesson(record)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  // 待开课 状态下 操作
  const renderToBeginAction = record => {
    const data = [
      {
        text: renderWatchLesson(record)
      },
      {
        text: renderDeleteLesson(record)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  // 跳转新建开课页面
  const handleJumpCreate = () => {
    router.push(
      `${getComposeUrl("/moralEducation/doubleTeacherClass/list/createClass")}`
    );
  };

  const columns = [
    {
      title: "主讲教室",
      dataIndex: "regionName",
      key: "regionName",
      width: 180,
      fixed: "left"
    },
    {
      title: "主讲教师",
      dataIndex: "teacherUserName",
      key: "teacherUserName",
      width: 120
    },
    {
      title: "学科",
      dataIndex: "courseName",
      key: "courseName",
      width: 180
    },
    {
      title: "课程名称",
      dataIndex: "lessonName",
      key: "lessonName",
      width: 330,
      render: lessonName =>
        lessonName ? (
          <Tooltip placement="top" title={lessonName}>
            <span>
              {lessonName?.length <= 20
                ? lessonName
                : `${lessonName?.substring(0, 12)}...`}
            </span>
          </Tooltip>
        ) : (
          "-"
        )
    },
    {
      title: "听课教室",
      key: "listenLessonName",
      width: 200,
      render: record => {
        const { regionList } = record;
        const nameList = [];
        if (regionList && regionList.length) {
          regionList.forEach(item => {
            nameList.push(item.regionName);
          });
        } else {
          return "-";
        }
        return nameList.length > 1 ? `${nameList[0]}...` : nameList[0];
      }
    },
    {
      title: "辅助教师",
      key: "subTeacherName",
      dataIndex: "subTeacherName",
      width: 120
    },
    {
      title: "开课时间",
      key: "startTime",
      render: record => {
        const { liveDate, startTime } = record;
        return startTime ? (
          <span>{`${moment(liveDate).format("YYYY.MM.DD")} ${startTime}`}</span>
        ) : (
          "-"
        );
      }
    },
    {
      title: "课程状态",
      key: "status",
      dataIndex: "status",
      width: 120,
      render: status => {
        return <Badge status={statusIcon[status]} text={statusText[status]} />;
      }
    },
    {
      title: "创建人",
      key: "createUserName",
      dataIndex: "createUserName",
      width: 120
    },
    {
      title: "操作",
      key: "action",
      width: 200,
      fixed: "right",
      render: record => {
        const { status } = record;
        const actionOfStatus = {
          1: renderToBeginAction(record),
          2: renderOnGoingAction(record),
          3: renderOnGoingAction(record)
        };
        return actionOfStatus[status];
      }
    }
  ];

  const containerProps = {
    breStates: 1,
    isSplitBar: 1
  };

  const { form } = props;

  const searchProps = {
    handleQueryChange,
    form,
    classRoomList
  };

  const listPageProps = {
    spinProps: {
      spinning: loading || pageLoading
    },
    className: styles.root
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    selfPageNation: pageInfo,
    onPageChange: handlePaginationChange
  };

  return (
    <Container {...containerProps}>
      <div className={styles.root}>
        <ListPage {...listPageProps}>
          <ListSearch {...searchProps} />
          <div className="divider" />
          <div className="buttonContainer">
            <Button onClick={handleJumpCreate} type="primary">
              + 开课
            </Button>
          </div>
          <ListTable {...tableProps} />
        </ListPage>
      </div>
    </Container>
  );
};

export default connect()(Form.create()(Selected));
